import { IconDownload, IconX } from '@veneer/core';
import {
  ModalPrinterComparisonAnalyticsPayload,
  ProductInfo,
  ProductSpecs,
} from './types';
import {
  FeatureDescription,
  FeatureNameSpecs,
  FeatureNameText,
  FeatureNameTextWrapper,
  FeatureUnitSpecs,
  Spec,
} from './styles';
interface PrinterSpecProps {
  printer: ProductInfo;
  fullSpecsLabel: string;
  onAnalytics?: (data: ModalPrinterComparisonAnalyticsPayload) => void;
}

const PrinterSpec: React.FC<PrinterSpecProps> = ({
  printer,
  fullSpecsLabel,
  onAnalytics,
}) => {
  const printerSpecs = printer.specs || ({} as ProductSpecs);

  if (!printerSpecs.url) {
    return (
      <Spec>
        <FeatureUnitSpecs>
          <IconX
            size={28}
            filled={false}
            style={{ marginBottom: '14px' }}
            data-testid="icon-x"
          />
        </FeatureUnitSpecs>
      </Spec>
    );
  }

  const handleClick = () => {
    if (onAnalytics) {
      onAnalytics({
        controlName: printerSpecs.controlName,
        controlDetail: printerSpecs.originalUrl
          ? printerSpecs.originalUrl
          : printerSpecs.url,
      });
    }
  };

  return (
    <Spec>
      <FeatureUnitSpecs>
        <FeatureNameSpecs
          className="caption-regular"
          href={printerSpecs.url}
          target="_blank"
          id={printerSpecs.controlName}
          rel="noopener noreferrer"
          data-testid="fullSpecsLink"
          onClick={() => handleClick()}
        >
          <IconDownload size={20} color="royalBlue7" />
          <FeatureNameTextWrapper>
            <FeatureNameText className="caption-regular">
              {fullSpecsLabel}
            </FeatureNameText>
          </FeatureNameTextWrapper>
        </FeatureNameSpecs>
        <FeatureDescription className="caption-regular">
          {printerSpecs.description}
        </FeatureDescription>
      </FeatureUnitSpecs>
    </Spec>
  );
};

export default PrinterSpec;
